const FEATURES = [
  {
    icon: 'ri-4k-line',
    title: '全高清画质',
    desc: '支持1080P超清播放，画质细腻色彩饱满，给您影院级的观影享受。西瓜视频同类型高清体验，每一帧都清晰动人。',
    color: 'bg-primary-100 text-primary-600',
  },
  {
    icon: 'ri-speed-up-line',
    title: '流畅不卡顿',
    desc: '采用智能CDN加速与P2P分发技术，全国多节点覆盖，高峰时段也能稳定播放。告别缓冲等待，即点即看，观影更畅快。',
    color: 'bg-accent-100 text-accent-600',
  },
  {
    icon: 'ri-film-line',
    title: '海量片库',
    desc: '收录超过3万部电影、电视剧、综艺、动漫资源，涵盖国内外热门内容。每日持续更新，追新剧、看经典，尽在白云视频。',
    color: 'bg-secondary-100 text-secondary-700',
  },
  {
    icon: 'ri-device-line',
    title: '全终端适配',
    desc: '电脑、平板、手机无缝切换，支持投屏到电视观看。无论在哪儿，白云视频都是您随身的免费影视平台，观影自由无界限。',
    color: 'bg-primary-100 text-primary-600',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading text-center mb-3">
          平台特色
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          四大核心优势，重新定义免费观影体验
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {FEATURES.map((f, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-2xl p-6 border border-background-200/60 hover:border-primary-200 transition-colors group"
            >
              <div className={`w-12 h-12 rounded-xl flex items-center justify-center mb-4 ${f.color}`}>
                <i className={`${f.icon} text-xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">
                {f.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {f.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}